import { NATIVE_MINT } from "@solana/spl-token";
import { ProposalAction } from "../../common/enums/proposals.enums";

export default {
  formId: "create-proposal",
  formFields: {
    proposalTitle: {
      label: "Proposal title",
      name: "proposalTitle",
      initialValue: "",
    },
    proposalDescription: {
      label: "Proposal description",
      name: "proposalDescription",
      initialValue: "",
    },
    link: {
      name: "link",
      label: "External discussion URL",
      initialValue: "",
    },
    proposalType: {
      label: "Proposal type",
      name: "proposalType",
      initialValue: "discussion",
    },
    proposalOption: {
      label: "Choose option",
      name: "proposalOption",
      initialValue: 0,
    },
    nftToBuy: {
      label: "NFT to buy",
      name: "nftToBuy",
      initialValue: "",
    },
    price: {
      label: "Price",
      name: "price",
      initialValue: "",
    },
    nft: {
      label: "Choose NFT from Vault",
      name: "nft",
      initialValue: "",
    },
    isMagicEdenNft: {
      label: "",
      name: "isMagicEdenNft",
      initialValue: false,
    },
    buyerAddress: {
      label: "Buyer address (Optional)",
      name: "buyerAddress",
      initialValue: "",
    },
    isNftMintValid: {
      label: "",
      name: "isNftMintValid",
      initialValue: false,
    },
    withdrawAmount: {
      label: "Amount to be withdrawn",
      name: "withdrawAmount",
      initialValue: "",
    },
    areAllDisabled: {
      label: "",
      name: "areAllDisabled",
      initialValue: false,
    },
    amountToInvest: {
      label: "Amount to transfer",
      name: "amountToInvest",
      initialValue: "",
    },
    transferAddress: {
      label: "Address to which funds are transferred",
      name: "transferAddress",
      initialValue: "",
    },
    mint: {
      label: "Mint",
      name: "mint",
      initialValue: NATIVE_MINT,
    },
    tokenAddress: {
      label: "Token account address",
      name: "tokenAddress",
      initialValue: null,
    },
    magicEdenNftData: {
      label: "",
      name: "magicEdenNftData",
      initialValue: null,
    },
    magicEdenErrors: {
      name: "magicEdenErrors",
      initialValue: false,
      label: "",
    },
    buyOption: {
      name: "buyOption",
      initialValue: "magicEden",
      label: "",
    },
    sellOption: {
      name: "sellOption",
      initialValue: "peerToPeer",
      label: "",
    },
    existingOffer: {
      name: "existingOffer",
      initialValue: "",
      label: "",
    },
    sellerFeeBps: {
      name: "sellerFeesBps",
      initialValue: 0,
      label: "",
    },
    newApprovalQuorum: {
      name: "newApprovalQuorum",
      label: "New approval quorum",
      initialValue: [],
    },
    governanceAccounts: {
      name: "governanceAccounts",
      label: "",
      initialValue: [],
    },
    newVotingTime: {
      name: "newVotingTime",
      label: "New voting time",
      initialValue: null,
    },
    governanceType: {
      name: "governanceType",
      label: "Change percentage for",
      initialValue: null,
    },
    roleVotes: {
      name: "roleVotes",
      initialValue: [],
      label: "",
    },
    activeTradeApprovalQuorum: {
      name: "activeTradeApprovalQuorum",
      label: "",
      initialValue: null,
    },
  },
};
